import { CommonModule } from '@angular/common'
import { AfterViewInit, ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { DomSanitizer } from '@angular/platform-browser'
import { AuthService } from '@auth/services/auth.service'
import { environment } from '@environments/environment'
import { NbCardModule } from '@nebular/theme'
import { DatabaseService } from '../../services/database.service'
/**
 * Edit registration dialog
 */
@Component({
  selector: 'ngx-edit-registration-modal',
  templateUrl: './edit-registration-modal.component.html',
  styleUrls: ['./edit-registration-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, NbCardModule, MatIconModule]
})
export class EditRegistrationModalComponent implements AfterViewInit {
  /**
   * Edit url passed to the iframe
   */
  @Input()
  editUrl: string

  /**
   * Listener for the message event
   */
  private listener: (event: MessageEvent) => void

  /**
   * Creates the component and injects it's dependancies
   * @param sanitizer DomSanitizer
   * @param auth AuthService
   */
  constructor(public sanitizer: DomSanitizer, public auth: AuthService, private databaseService: DatabaseService) {}

  /**
   * Listen to the iframe height message and close the dialog when the form is submitted
   * @returns void
   */
  ngAfterViewInit(): void {
    window.addEventListener('message', (event) => {
      if (event.data?.status) this.databaseService.closeDialog()
    })
    window.addEventListener('message', this.listener)
  }

  /**
   * Remove the iframe height listener
   * @returns void
   */
  ngOnDestroy(): void {
    window.removeEventListener('message', this.listener)
  }

  /**
   * Final editing url sanitized
   */
  get targetUrl(): any {
    const url = `${environment.publicFormsUrl}workspaces/${this.auth.currentWorkspace.slug}${this.editUrl}`

    return this.sanitizer.bypassSecurityTrustResourceUrl(url)
  }

  /**
   * Closes the dialog
    @returns void 
  */
  closeDialog(): void {
    this.databaseService.closeDialog()
  }
}
